import React, {useEffect, useState, Fragment, useMemo} from 'react';
import {
  Link,
  NavLink
} from "react-router-dom";

import { Popover, Transition } from '@headlessui/react';
import { connect } from 'react-redux';
import { NavHashLink } from 'react-router-hash-link';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { BookmarkSquareIcon, CalendarIcon, ShieldCheckIcon, LifebuoyIcon } from '@heroicons/react/24/outline'

import { useRouteMatch, useLocation, useResolvedPath } from "react-router-dom";

import BuddyFullLogo from '../../assets/images/buddy-logo-full.png'
import BuddyFullLogoOrange from '../../assets/images/buddy-logo-full.png'
import BuddyFace from '../../assets/images/buddy-face.png';

import buddySvg from '../../assets/images/buddy-svg';

const tools = [
  {
    name: 'Salary Calculator',
    description: 'Learn the true cost of a new hire, including bonuses and all employer contributions.',
    href: 'salary-calculator',
    jurisdiction: ['mt'],
  },
  {
    name: 'Cost of Living Report',
    description: 'Understand the impact of the annual cost of living adjustments, changes in net salary and all contributions.',
    href: 'cola-report',
    jurisdiction: ['mt'],
  },
  {
    name: 'Notice Period Calculator',
    description: 'Calculate Notice Periods, and related payments due on termination.',
    href: 'notice-period-calculator',
    jurisdiction: ['mt'],
  },
]

const resources = [
  {
    name: 'Articles',
    description: 'Learn key aspects of HR & Payroll through an array of in-depth articles.',
    path: 'articles',
    icon: BookmarkSquareIcon,
    jurisdiction: ['mt','uk'],
  },
  /* {
    name: 'Courses',
    description: 'Learn how to do payroll like a pro, with an array of specialised payroll courses.',
    path: 'learn',
    icon: AcademicCapIcon,
    jurisdiction: ['mt'],
  }, */
  {
    name: 'Webinars',
    description: 'See what meet-ups and other events we might be planning near you.',
    path: 'webinar',
    icon: CalendarIcon,
    jurisdiction: ['mt','uk'],
  },
  // { name: 'Security', description: 'Understand how we take your privacy seriously.', href: '#', icon: ShieldCheckIcon },
  {
    name: 'Help Center',
    description: 'Access our in-depth support library, or reach out to our team.',
    href: 'https://support.buddy.hr/hc/en-mt',
    icon: LifebuoyIcon,
    jurisdiction: ['mt'],
  },
  {
    name: 'Help Center',
    description: 'Access our in-depth support library, or reach out to our team.',
    href: 'https://support.buddy.hr/hc/en-gb',
    icon: LifebuoyIcon,
    jurisdiction: ['uk'],
  },
]


const features = [
  {
    name: 'Employee',
    description: 'Discover how Buddy can help you as an employee.',
    href: 'cola-report',
    jurisdiction: ['uk','mt'],
  },
  {
    name: 'Employer',
    description: 'Paying your staff accurately is important, discover how Buddy helps you be a compliant employer.',
    href: 'salary-calculator',
    jurisdiction: ['uk','mt'],
  },
  {
    name: 'Payroll Bureau',
    description: 'Doing Payroll for clients? Here\'s everything you need to know.',
    href: 'notice-period-calculator',
    jurisdiction: ['uk','mt'],
  },
]


const mobileNav = [
  {
    name: 'Home',
    to: '',
    country: ['uk', 'mt', 'ie']
  },
  {
    name: 'Employer Pricing',
    to: 'employer/pricing',
    country: ['uk', 'mt'],
    // persona: ['employer','payroll-bureau']
  },
  {
    name: 'Bureau Pricing',
    to: 'payroll-bureau/pricing',
    country: ['uk', 'mt'],
    // persona: ['employer','payroll-bureau']
  },
  {
    name: 'Salary Calculator',
    to: 'salary-calculator',
    country: ['mt']
  },
  {
    name: 'Cost of Living Report',
    to: 'cola-report',
    country: ['mt']
  },
  {
    name: 'Notice Period Calculator',
    to: 'notice-period-calculator',
    country: ['mt']
  },
  /* {
    name: 'Learn',
    to: 'learn',
    country: ['mt']
  }, */
  {
    name: 'Articles',
    to: 'articles',
    country: ['mt','uk']
  },
  {
    name: 'Webinars',
    to: 'webinar',
    country: ['mt','uk']
  },
  {
    name: 'Help Center',
    description: 'Access our in-depth support library, or reach out to our team.',
    href: 'https://support.buddy.hr/hc/en-mt',
    icon: LifebuoyIcon,
    country: ['mt'],
  },
  {
    name: 'Help Center',
    description: 'Access our in-depth support library, or reach out to our team.',
    href: 'https://support.buddy.hr/hc/en-gb',
    icon: LifebuoyIcon,
    country: ['uk'],
  },
  {
    name: 'About',
    to: 'about',
    country: ['mt','uk']
  }
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function Navbar({
  profile,
  loggedIn,
  recentPosts,
  marketingFilters,
  hiddenFilters,
}) {
  let location = useLocation();

  const countryCode = location.pathname.split('/')[1]
  const country = ['uk', 'mt', 'ie'].includes(countryCode) ? '/' + countryCode + '/' : ''
  const primaryCtaLabel = countryCode === 'uk' ? 'Request a demo' : 'Start free trial'

  const personaSlug = location.pathname.split('/')[2]
  const defaultPersona = countryCode === 'uk' ? 'payroll-bureau' : 'employer'
  const persona = ['employee', 'employer', 'payroll-bureau'].includes(personaSlug) ? personaSlug + '/' : `${defaultPersona}/`

  const toolsThisCountry = useMemo(() => {
    return tools.filter(tool => tool.jurisdiction.includes(countryCode))
  }, [country]);

  const resourcesThisCountry = useMemo(() => {
    return resources.filter(resource => resource.jurisdiction.includes(countryCode))
  }, [country]);

  const mobileNavThisCountry = useMemo(() => {
    return mobileNav.filter(item => item.country.includes(countryCode))
  })

  // const path = useResolvedPath()
  // console.log('path',path,location)
  const hideSupportButton = document.getElementById('launcher')
  // let match = useRouteMatch("/blog/:slug");

  const hideSupport = () => {
    window.zE?.(() => {
      if (marketingFilters.includes(location.pathname) || hiddenFilters.includes(location.pathname)) {
        window.zE.hide()
      } else {
        window.zE.show()
      }
    })
  }

  useEffect(() => {
    hideSupport()
  }, [location])

  useEffect(() => {
    hideSupport()
  }, [])

  const [isMenuOpen, setIsMenuOpen] = useState(false)


  if (hiddenFilters.findIndex(filter => location.pathname.includes(filter)) >= 0) {
    return null
  }

  // exceptions when to hide menu navbar
  if (marketingFilters.findIndex(filter => location.pathname.includes(filter)) >= 0) {
    return (
      <header>
        <nav className="pt-6 pb-6 relative max-w-screen-xl mx-auto flex items-center justify-evenly lg:justify-start px-4 sm:px-6">
          <div className='h-16'>
            <NavLink to={country} aria-label="Home">
              <img className="h-20" src={BuddyFullLogo} alt="Buddy HR Payroll Software Logo" />
            </NavLink>
          </div>
        </nav>
      </header>
    )
  }

  return (

    <header>
      <nav className="pt-6 pb-5 relative max-w-screen-xl mx-auto flex items-center justify-between px-4 sm:px-6 z-10">
        <div className="flex items-center flex-1">
          <div className="flex items-center justify-between w-full md:w-auto">
            <NavLink to={country} aria-label="Home" className={"logo-w"}>
              <div style={{
                transform: "scale(1.7)",
                transformOrigin: "left top",
                marginRight: "5rem"
              }}>
                {buddySvg}
              </div>
              {/*<img
                    className="h-16 w-auto md:h-20"
                   style={{
                      transform: "translateY(-50%)",
                      marginBottom: "-50%"
                   }}
                   src={BuddyFullLogo}
                   alt="Buddy HR Payroll Software Logo"
              />*/}
            </NavLink>
            <div className="-mr-2 flex items-center md:hidden">
              <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:bg-gray-700 focus:outline-none focus:bg-gray-700 transition duration-150 ease-in-out"
                onClick={() => setIsMenuOpen(true)}
              >
                <span className="sr-only">Close menu</span>
                <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
          <div className="hidden space-x-6 lg:space-x-10 md:flex sm:ml-6 lg:ml-10 lg:text-lg">
            <NavLink
              to={country}
              className="font-medium text-white hover:text-gray-300 transition duration-150 ease-in-out"
            >
              Home
            </NavLink>
            <NavLink
              to={country + persona + "pricing"}
              className="font-medium text-white hover:text-gray-300 transition duration-150 ease-in-out"
            >
              Pricing
            </NavLink>
            <NavLink
              to={country + "about"}
              className="font-medium text-white hover:text-gray-300 transition duration-150 ease-in-out"
            >
              About
            </NavLink>
            {/*<NavHashLink
                to="/#team"
                className="font-medium text-white hover:text-gray-300 transition duration-150 ease-in-out"
                >
                Team
              </NavHashLink>*/}


            {
              toolsThisCountry.length > 0 &&
              <Popover className="relative">
                {({ open, close }) => (
                  <>
                    <Popover.Button
                      className={classNames(
                        open ? 'text-white' : 'text-white',
                        'group bg-gray-800 rounded-md inline-flex items-center text-base font-medium hover:text-gray-100 focus:outline-none'
                      )}
                    >
                      <span>Tools</span>
                      <ChevronDownIcon
                        className={classNames(
                          open ? 'text-white' : 'text-white',
                          'ml-2 h-5 w-5 group-hover:text-gray-100'
                        )}
                        aria-hidden="true"
                      />
                    </Popover.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-xs sm:px-0">
                        <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                          <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                            {toolsThisCountry.map((item) => (
                              <NavLink
                                onClick={() => close()}
                                key={item.name} to={country + item.href} className="-m-3 p-3 block rounded-md hover:bg-gray-50">
                                <p className="text-base font-medium text-gray-900">{item.name}</p>
                                <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                              </NavLink>
                            ))}
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </>
                )}
              </Popover>
            }
            {/*<NavLink
                to="/learn"
                className="font-medium text-white hover:text-gray-300 transition duration-150 ease-in-out"
                >
                Learn
              </Link>*/}

            { resourcesThisCountry.length > 0 &&
              <Popover className="relative">
                {({ open, close }) => (
                  <>
                    <Popover.Button
                      className={classNames(
                        open ? 'text-white' : 'text-white',
                        'group bg-gray-800 rounded-md inline-flex items-center text-base font-medium hover:text-gray-100 focus:outline-none'
                      )}
                    >
                      <span className=" lg:text-lg">Learn Payroll</span>
                      <ChevronDownIcon
                        className={classNames(
                          open ? 'text-white' : 'text-white',
                          'ml-2 h-5 w-5 group-hover:text-gray-100'
                        )}
                        aria-hidden="true"
                      />
                    </Popover.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-md sm:px-0">
                        <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                          <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                            {resourcesThisCountry.map((item) => (
                              item.href ?
                                <a
                                  key={item.name}
                                  href={item.href}
                                  target="_blank"
                                  className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50 transition ease-in-out duration-150"
                                >
                                  <item.icon className="flex-shrink-0 h-6 w-6 text-orange-600" aria-hidden="true" />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-gray-900">{item.name}</p>
                                    <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                                  </div>
                                </a>
                                :
                                <NavLink
                                  onClick={() => close()}
                                  key={item.name}
                                  to={country + item.path}
                                  className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50 transition ease-in-out duration-150"
                                >
                                  <item.icon className="flex-shrink-0 h-6 w-6 text-orange-600" aria-hidden="true" />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-gray-900">{item.name}</p>
                                    <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                                  </div>
                                </NavLink>
                            ))}
                          </div>
                          <div className="px-5 py-5 bg-gray-50 sm:px-8 sm:py-8">
                            <div>
                              <h3 className="text-sm tracking-wide font-medium text-gray-500 uppercase">Recent Articles</h3>
                              <ul role="list" className="mt-4 space-y-4">
                                {recentPosts?.map((post) => (
                                  <li key={post.slug} className="text-base truncate">
                                    <NavLink
                                      onClick={() => close()}
                                      to={`${country}a/${post.slug}`}
                                      className="font-medium text-gray-900 hover:text-gray-700 transition ease-in-out duration-150"
                                    >
                                      {post.name}
                                    </NavLink>
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <div className="mt-5 text-sm">
                              <NavLink
                                onClick={() => close()}
                                to={`${country}articles`}
                                className="font-medium text-orange-600 hover:text-orange-500 transition ease-in-out duration-150"
                              >
                                {' '}
                                View all articles <span aria-hidden="true">&rarr;</span>
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </>
                )}
              </Popover>
            }

            {/*<NavLink
              to={`${country}blog`}
              className="font-medium text-white hover:text-gray-300 transition duration-150 ease-in-out"
            >
              Blog
            </NavLink>*/}
          </div>
        </div>
        <div className="hidden md:flex">
          {loggedIn ?
            <span href="#" className="inline-flex items-center px-4 py-2 border-transparent text-sm leading-5 font-medium text-white">
              Hi, {profile.givenName || profile.name}
            </span>
              :
            <NavLink to={`${country}start`} className="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:shadow-outline-gray focus:border-orange-700 active:bg-orange-700 transition duration-150 ease-in-out mr-5">
              {primaryCtaLabel}
            </NavLink>
          }

          <NavLink to={`login`} className="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-gray-600 hover:bg-gray-500 focus:outline-none focus:shadow-outline-gray focus:border-gray-700 active:bg-gray-700 transition duration-150 ease-in-out">
            {loggedIn ? `Go to My Account` : `Log in`}
          </NavLink>
        </div>
      </nav>
      <Transition
        show={isMenuOpen}
        enter="duration-150 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
        onClick={() => setIsMenuOpen(false)}
      >
        <div className="absolute top-0 inset-x-0 p-2 transition transform origin-top md:hidden z-50">
          <div className="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
            <div className="px-5 pt-3 flex items-center justify-between">
              <div>
                <NavLink to={country} aria-label="Home">
                  {buddySvg}
                  {/*<img className="h-8 w-auto scale-150" src={BuddyFullLogoOrange} alt="Buddy HR Payroll Software Logo" />*/}
                </NavLink>
              </div>
              <div className="-mr-2">
                <button type="button" className="rounded-md p-2 inline-flex items-center justify-center text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-secondary-600">
                  <span className="sr-only">Close menu</span>

                  <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="pt-5 pb-6">
              <div className="px-2 space-y-1">
                {mobileNavThisCountry.map((item) => (
                    <NavLink
                        key={item.name}
                        to={item.to ? (country + (item.persona ? persona : '') + item.to) : item.href}
                        className="block px-3 py-2 rounded-md text-base font-medium text-gray-800 transition duration-150 ease-in-out"
                        onClick={() => setIsMenuOpen(false)}
                    >
                      {item.name}
                    </NavLink>
                ))}
                <NavLink
                    to={`login`}
                    onClick={() => setIsMenuOpen(false)}
                    className="w-full justify-center inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-orange-500 shadow-transition duration-150 ease-in-out">
                  {loggedIn ? `Go to My Account` : `Log in`}
                </NavLink>
              </div>
              {/*<div className="mt-6 px-5">
                <a href="#" className="block text-center w-full py-3 px-4 rounded-md shadow bg-gradient-to-r from-primary-500 to-secondary-600 text-white font-medium hover:from-primary-600 hover:to-secondary-700">Start free trial</a>
              </div>
              <div className="mt-6 px-5">
                <p className="text-center text-base font-medium text-gray-500">Existing customer? <a href="#" className="text-gray-900 hover:underline">Login</a></p>
              </div>*/}
            </div>
          </div>
        </div>
      </Transition>
    </header>
  );
}



/*<!--
  Mobile menu, show/hide based on menu open state.

  Entering: "duration-150 ease-out"
    From: "opacity-0 scale-95"
    To: "opacity-100 scale-100"
  Leaving: "duration-100 ease-in"
    From: "opacity-100 scale-100"
    To: "opacity-0 scale-95"
-->
<div className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
  <div className="rounded-lg shadow-md">
    <div className="rounded-lg bg-white shadow-xs overflow-hidden" role="menu" aria-orientation="vertical" aria-labelledby="main-menu">
      <div className="px-5 pt-4 flex items-center justify-between">
        <div>
          <img className="h-8 w-auto" src="https://tailwindui.com/img/logos/v1/workflow-mark-on-white.svg" alt="">
        </div>
        <div className="-mr-2">
          <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out" aria-label="Close menu">
            <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <div className="space-y-1 px-2 pt-2 pb-3">
        <a href="#" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Product</a>
        <a href="#" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Features</a>
        <a href="#" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Marketplace</a>
        <a href="#" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Company</a>
      </div>
      <div>
        <a href="#" className="block w-full px-5 py-3 text-center font-medium text-orange-600 bg-gray-50 hover:bg-gray-100 hover:text-orange-700 focus:outline-none focus:bg-gray-100 focus:text-orange-700 transition duration-150 ease-in-out" role="menuitem">
          Log in
        </a>
      </div>
    </div>
  </div>
</div>*/

const mapStateToProps = (state, ownProps) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    loggedIn: state.my.profile ? true : false,
    profile: state.my.profile,
    recentPosts: state.articles && state.articles.slice(0, 3),
    marketingFilters: state.navBarOverride.marketing,
    hiddenFilters: state.navBarOverride.hide,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navbar)
